import React, { useContext } from 'react'
import type { QuoteFile } from 'paintscout'

import { FormikContext } from 'formik'

import { makeStyles, Grid, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { useDialogs } from '@paintscout/ui-business'
import type { PresentationSectionProps } from '../../'

import { FilesLightboxDialog } from '../../../dialogs'

import FilesGrid from '../../../FilesGrid'

const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
  content: {},
  filePreview: {
    '& img': {
      aspectRatio: '4/3',
      objectFit: 'cover'
    }
  }
}))

export default function Gallery(props: PresentationSectionProps) {
  const classes = useStyles(props)
  const { openDialog, dismissDialog } = useDialogs()
  const { section, WrapperComponent } = props
  // this bit of magic allows this component to be used inside or outside of formik without conditional hooks or throwing errors/warnings
  const formikContext = useContext(FormikContext)

  const { fields, title } = section
  const { files, columns, showBorder } = fields

  return (
    <WrapperComponent {...props}>
      <Grid container spacing={3} justifyContent={'center'} alignItems={'flex-start'}>
        {title && (
          <Grid item md={12}>
            <Typography variant={'h2'}>{title}</Typography>
          </Grid>
        )}
        <Grid item xs={12} classes={{ root: classes.filePreview }}>
          <FilesGrid
            editable={props.editFromDialog}
            onReorder={handleReorder}
            justify="space-around"
            files={files}
            columns={columns}
            showBorder={showBorder}
            onFileClick={handleFileClick}
          />
        </Grid>
      </Grid>
    </WrapperComponent>
  )

  function handleReorder(reorderedFiles: QuoteFile[]) {
    const { setValues } = formikContext
    setValues({
      section: {
        ...section,
        fields: {
          ...section.fields,
          files: reorderedFiles
        }
      }
    })
  }

  function handleFileClick(index: number) {
    // Customer-facing presentation always uses the legacy lightbox — the new file
    // editor is reserved for the contractor's editing flows, not the recipient view.
    openDialog(FilesLightboxDialog, {
      files,
      index,
      onClose: dismissDialog
    })
  }
}
